var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"platform-editor-access",attrs:{"role":"status"}},[(!_vm.error)?_c('i',{staticClass:"el-icon-loading",attrs:{"aria-hidden":"true"}}):_vm._e(),_c('p',[_vm._v(_vm._s(_vm.error || '正在接入平台登录信息…'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }